import { render } from "./SellerTerms.vue?vue&type=template&id=6cbc6f61&scoped=true"
import script from "./SellerTerms.vue?vue&type=script&lang=js"
export * from "./SellerTerms.vue?vue&type=script&lang=js"

import "./SellerTerms.styles.css?vue&type=style&index=0&id=6cbc6f61&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbc6f61"]])

export default __exports__